export interface ClassroomDeleteRequest {
  classroomId: string;
}
export const classroomDelete = createAsyncThunk(
  "classroomDelete",
  async (param: ClassroomDeleteRequest, thunkAPI) => {
    console.debug("delete classroom");
    const response = await fetch(`${getBackendUrl()}/api/classroom/${param.classroomId}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      }
    });
    if(response.ok) {
      return { classroomId: param.classroomId };
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, getImagesUrl, failedResponse } from "../common";
import { ClassroomInfo } from "./classroomSlice";
import { getToken } from "../../features/user/UserAvatar";

export interface ClassroomInsUptState {
  state: LoadStateInfo;
  classroom: ClassroomInfo;
}

const initialState: ClassroomInsUptState = {
  state: notStarted(),
  classroom: emptyClassroom(),
};

function emptyClassroom() {
  return {
    id: "",
    name: "",
    year: `${new Date().getFullYear()}`,
    url: `${getImagesUrl()}/default/classroom.webp`,
    schoolId: "",
    classroomStatus: 2,
    imageProcessorStyle: 0,
  } as ClassroomInfo;
}

export interface ClassroomInsertRequest {
  classroom: ClassroomInfo;
}
export const classroomInsert = createAsyncThunk(
  "classroomInsert",
  async (param: ClassroomInsertRequest, thunkAPI) => {
    console.debug("insert classroom");
    const response = await fetch(`${getBackendUrl()}/api/classroom`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.classroom)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface ClassroomUpdateRequest {
  classroomId: string;
  classroom: ClassroomInfo;
}
export const classroomUpdate = createAsyncThunk(
  "classroomUpdate",
  async (param: ClassroomUpdateRequest, thunkAPI) => {
    console.debug("update classroom", param);
    const response = await fetch(`${getBackendUrl()}/api/classroom/${param.classroomId}`, {
      method: "PUT",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.classroom)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const classroomInsUpdSlice = createSlice({
  name: "classroomInsUpd",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<ClassroomInfo>) => {
      state.state = notStarted();
      state.classroom = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.classroom = emptyClassroom();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(classroomInsert.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(classroomInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.classroom = action.payload;
      })
      .addCase(classroomInsert.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(classroomUpdate.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(classroomUpdate.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.classroom = action.payload;
      })
      .addCase(classroomUpdate.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(classroomDelete.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(classroomDelete.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.classroom = emptyClassroom();
      })
      .addCase(classroomDelete.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

// export const { } = classroomInsUpdSlice.actions;

export const selectClassroomInsUpd = (state: RootState) => state.classroomInsUpd;

export default classroomInsUpdSlice.reducer;
